export const TransactionMethod = {
  InstantPay: "instant_pay",
  NextDayAch: "next_day_ach",
  Paycard: "paycard",
  SameDayAch: "same_day_ach",
  Wire: "wire",
} as const;
export type TransactionMethod =
  (typeof TransactionMethod)[keyof typeof TransactionMethod];
